// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.styles_botaoUpload__d6ZbR,
.styles_botaoUploadOk__PdyvV {
  height: 2.5rem !important;
  font-size: 1rem !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-transform: capitalize !important;
  font-family: "Inter" !important;
  color: #fff !important;
}

.styles_botaoUpload__d6ZbR {
  border-radius: 4px !important;
  background-color: #4b6fc0 !important;
}

.styles_botaoUploadOk__PdyvV {
  background-color: #31c96f !important;
}


.styles_container_button__zwAf6{
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.styles_button_next__-dZOa {
  background-color: #18316e !important;
  color: #ffffff !important;
  font-family: "Inter" !important;
  font-weight: 400 !important;
  padding: .4rem 1.5rem !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
}

.styles_button_next__-dZOa:hover {
  transform: scale(0.95) !important;
  opacity: 0.9;
}

.styles_button_back__ZL2YN {
  background-color: #fff !important;
  border: 1px solid #18316e !important;
  color: #18316e !important;
  font-family: "Inter" !important;
  font-weight: 400 !important;
  padding: .4rem 1.5rem !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
}

.styles_button_back__ZL2YN:hover {
  transform: scale(0.95) !important;
  opacity: 0.9;
}

.styles_textFieldAnexoFaltando__3SRXK {
  border-left: solid !important;
  border-bottom: solid !important;
  border-right: solid !important;
  border-width: 2px !important;
  border-color: red !important;
  border-radius: 6px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/CadastroDetalhado/Documentos/styles.module.css"],"names":[],"mappings":";AACA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;EAChC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,gCAAgC;EAChC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;AAC/B","sourcesContent":["\n.botaoUpload,\n.botaoUploadOk {\n  height: 2.5rem !important;\n  font-size: 1rem !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  text-transform: capitalize !important;\n  font-family: \"Inter\" !important;\n  color: #fff !important;\n}\n\n.botaoUpload {\n  border-radius: 4px !important;\n  background-color: #4b6fc0 !important;\n}\n\n.botaoUploadOk {\n  background-color: #31c96f !important;\n}\n\n\n.container_button{\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.button_next {\n  background-color: #18316e !important;\n  color: #ffffff !important;\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  padding: .4rem 1.5rem !important;\n  text-transform: none !important;\n  transition: all 0.3s ease !important;\n}\n\n.button_next:hover {\n  transform: scale(0.95) !important;\n  opacity: 0.9;\n}\n\n.button_back {\n  background-color: #fff !important;\n  border: 1px solid #18316e !important;\n  color: #18316e !important;\n  font-family: \"Inter\" !important;\n  font-weight: 400 !important;\n  padding: .4rem 1.5rem !important;\n  text-transform: none !important;\n  transition: all 0.3s ease !important;\n}\n\n.button_back:hover {\n  transform: scale(0.95) !important;\n  opacity: 0.9;\n}\n\n.textFieldAnexoFaltando {\n  border-left: solid !important;\n  border-bottom: solid !important;\n  border-right: solid !important;\n  border-width: 2px !important;\n  border-color: red !important;\n  border-radius: 6px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"botaoUpload": `styles_botaoUpload__d6ZbR`,
	"botaoUploadOk": `styles_botaoUploadOk__PdyvV`,
	"container_button": `styles_container_button__zwAf6`,
	"button_next": `styles_button_next__-dZOa`,
	"button_back": `styles_button_back__ZL2YN`,
	"textFieldAnexoFaltando": `styles_textFieldAnexoFaltando__3SRXK`
};
export default ___CSS_LOADER_EXPORT___;
